(() => {
  'use strict';
  const handle = 'hematix-daily-t-support';
  const homePath = '/pages/gummies-home';
  const isProduct = location.pathname.replace(/\/$/, '').endsWith('/products/' + handle);
  const home = document.querySelector('.hgh[data-gummies-home]');
  const isHome = !!home || location.pathname.replace(/\/$/, '').endsWith(homePath);
  const isSupport = document.documentElement.classList.contains('hb-support-context');
  if (!isProduct && !isHome && !isSupport) return;
  if (document.documentElement.hasAttribute('data-hb-gummies-routing-ready')) return;
  document.documentElement.setAttribute('data-hb-gummies-routing-ready', '');
  const parameters = new URLSearchParams(location.search);
  const isSoft = value => value === 'soft' || value === 'hematix-gummies-soft';
  let homeProductView;
  try { homeProductView = new URL(home?.dataset.productUrl || '', location.href).searchParams.get('view'); } catch {}
  const softView = isSoft(parameters.get('view')) || isSoft(parameters.get('hmx_view')) ||
    document.querySelector('[data-gummies-product-view="soft"]') !== null || isSoft(homeProductView);
  const homeSelectors = '[data-gummies-home-link], #hb-source-header .hd-logo, .hb-support-logo, ' +
    '.header__heading-link, .header__menu-item, .menu-drawer__menu-item, ' +
    '.hb-footer small a, .footer__copyright a, .hg-breadcrumb a';
  const carryView = url => {
    if (softView) url.searchParams.set('hmx_view', 'soft');
    else url.searchParams.delete('hmx_view');
  };
  // Keep context in links so a later general-home or bracelet visit remains unchanged.
  const contextualise = () => {
    document.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      let url;
      try { url = new URL(href, location.href); } catch { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === homePath || url.pathname === homePath + '/' ||
          (url.pathname === '/' && link.matches(homeSelectors))) {
        url.pathname = homePath;
        // Shopify's view parameter selects a page template, so use a separate context parameter.
        url.searchParams.delete('view');
        carryView(url);
      } else if (/\/pages\/contact\/?$/.test(url.pathname)) {
        url.searchParams.set('view', 'gummies');
        carryView(url);
      } else if (/\/apps\/parcelpanel\/?$/.test(url.pathname)) {
        url.searchParams.set('hmx_product', handle);
        carryView(url);
      } else if (url.pathname.replace(/\/$/, '').endsWith('/products/' + handle)) {
        if (softView) url.searchParams.set('view', 'soft');
        else if (isHome && isSoft(url.searchParams.get('view'))) url.searchParams.delete('view');
        url.searchParams.delete('hmx_view');
      } else return;
      if (parameters.has('preview_theme_id') && !url.searchParams.has('preview_theme_id')) {
        url.searchParams.set('preview_theme_id', parameters.get('preview_theme_id'));
      }
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
    const returnField = document.querySelector('#ContactForm.hb-support-form input[name="return_to"]');
    if (returnField) {
      let url;
      try { url = new URL(returnField.value, location.href); } catch { return; }
      if (url.origin === location.origin && /\/pages\/contact\/?$/.test(url.pathname)) {
        url.searchParams.set('view', 'gummies');
        carryView(url);
        if (parameters.has('preview_theme_id')) url.searchParams.set('preview_theme_id', parameters.get('preview_theme_id'));
        returnField.value = url.pathname + url.search + url.hash;
      }
    }
  };
  contextualise();
  // Capture links added by the tracking application, without observing its rendering loop.
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (link) contextualise();
  }, true);
  document.addEventListener('shopify:section:load', contextualise);
})();
